// src/pages/Dashboard/Admin/Inventaire/components/InventaireMobileCards.jsx

import React from "react";
import { FaEdit, FaTrash } from "react-icons/fa";

import {
  getInventairePhotoSrc,
  getStockStatus,
  getStockStatusClass,
  getStockStatusLabel,
  toStockNumber,
} from "../utils/inventaireDashboardUtils";

export default function InventaireMobileCards({
  items = [],
  onEdit,
  onDelete,
  deletingId,
}) {
  return (
    <div className="space-y-3 md:hidden">
      {items.map((item) => {
        const stockStatus = getStockStatus(item);

        return (
          <article
            key={`mobile-${item.id}`}
            className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900/60"
          >
            <div className="flex gap-3 p-3">
              <img
                src={getInventairePhotoSrc(item.photo_url)}
                alt={item.nom || "Objet inventaire"}
                className="h-20 w-20 shrink-0 rounded-2xl object-cover ring-1 ring-slate-200 dark:ring-slate-700"
                onError={(event) => {
                  event.currentTarget.src = "/img/no-image.jpg";
                }}
              />

              <div className="min-w-0 flex-1">
                <div className="flex items-start justify-between gap-2">
                  <div className="min-w-0">
                    <h3 className="truncate text-sm font-bold text-slate-900 dark:text-white">
                      {item.nom || "—"}
                    </h3>

                    <p className="mt-0.5 text-xs font-medium text-slate-500 dark:text-slate-400">
                      {item.categorie || "—"}
                    </p>
                  </div>

                  <span className="inline-flex min-w-12 items-center justify-center rounded-2xl border border-slate-200 bg-slate-50 px-2.5 py-1 text-sm font-bold text-slate-900 dark:border-slate-700 dark:bg-slate-800 dark:text-white">
                    {toStockNumber(item.stock)}
                  </span>
                </div>

                <div className="mt-2">
                  <span
                    className={`inline-flex rounded-full px-2.5 py-1 text-[11px] font-bold ring-1 ${getStockStatusClass(
                      stockStatus
                    )}`}
                  >
                    {getStockStatusLabel(stockStatus)}
                  </span>
                </div>

                {item.note ? (
                  <p className="mt-2 line-clamp-2 text-xs leading-5 text-slate-600 dark:text-slate-300">
                    {item.note}
                  </p>
                ) : null}

                <div className="mt-3 flex items-center gap-2">
                  <button
                    type="button"
                    onClick={() => onEdit(item)}
                    className="inline-flex items-center justify-center gap-2 rounded-xl border border-slate-200 bg-white px-3 py-2 text-xs font-bold text-slate-700 transition hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200"
                  >
                    <FaEdit />
                    Modifier
                  </button>

                  <button
                    type="button"
                    onClick={() => onDelete(item)}
                    disabled={deletingId === item.id}
                    className="inline-flex items-center justify-center gap-2 rounded-xl border border-rose-200 bg-rose-50 px-3 py-2 text-xs font-bold text-rose-700 transition hover:bg-rose-100 disabled:opacity-50 dark:border-rose-500/20 dark:bg-rose-500/10 dark:text-rose-300"
                  >
                    <FaTrash />
                    Supprimer
                  </button>
                </div>
              </div>
            </div>
          </article>
        );
      })}
    </div>
  );
}